import { jsx as _jsx } from "react/jsx-runtime";
const BoardIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("g", Object.assign({ id: "Icon" }, { children: _jsx("path", { id: "Vector", d: "M15 19L9 16.89V5L15 7.11M20.5 3C20.44 3 20.39 3 20.34 3L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.6326 3.05268 20.7598 3.14645 20.8536C3.24021 20.9473 3.36739 21 3.5 21C3.55 21 3.61 21 3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19 21 18.85 21 18.62V3.5C21 3.36739 20.9473 3.24021 20.8536 3.14645C20.7598 3.05268 20.6326 3 20.5 3Z", fill: props.color }) })) })));
};
BoardIcon.defaultProps = {
    color: 'white',
};
export default BoardIcon;
